export default "__VITE_ASSET__B59CLdZq__"